export const RestaurantStory = (data) => {
  return { 
    locationId: (data.hasOwnProperty("locationId")) ? data.locationId : null,
    localStoryId: (data.hasOwnProperty("localStoryId")) ? data.localStoryId : null,
    title: (data.hasOwnProperty("title")) ? data.title : null,
    content: (data.hasOwnProperty("content")) ? data.content : null,
    image: (data.hasOwnProperty("image")) ? data.image : null,
    hasImage: (data.hasOwnProperty("hasImage")) ? data.hasImage : null
  } 
}